<template>
  <div class="bg-light">
    <h1 v-if="loading" class="loading text-muted">
      <h2 class="text-muted"><i class="fa fa-spinner fa-spin"></i> Loading...</h2>
    </h1>
    <div v-else id="detail" class="card my-3">
      <div>
        <div class="card-body">
          <div class="row">
            <div class="col-8">
              <div class="row border-bottom">
                <div class="d-flex col-12 mb-3 align-items-center justify-content-between">
                  <h5 class="m-0">{{ order.po_number }}</h5>
                  <div class="d-flex">
                    <div class="btn-group m-0" v-if="readonly">
                      <button class="btn btn-outline-dark btn-sm" @click="edit">EDIT</button>
                    </div>
                    <div v-else class="btn-group m-0">
                      <button class="btn btn-outline-success btn-sm" @click="saveEdit">SAVE</button>
                      <button class="btn btn-outline-danger btn-sm ml-2" @click="cancelEdit">CANCEL</button>
                    </div>
                    <action-buttons :order="order"></action-buttons>
                  </div>
                </div>              
              </div>
              <div class="row mt-3">
                <div class="col-6">
                  <div class="form-group">
                    <label>PO NUMBER</label>
                    <input :disabled="readonly" type="text" class="form-control form-control-sm" v-model="order.po_number" />
                  </div>
                  <div class="form-group">
                    <label>CONTAINER NUMBER</label>
                    <input :disabled="readonly" type="text" class="form-control form-control-sm" v-model="order.container_number" />
                  </div>
                  <div class="form-group">
                    <label>STATUS</label>
                    <input disabled type="text" class="form-control form-control-sm" v-model="order.status.name" />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label>CREATED</label>
                    <input disabled type="email" class="form-control form-control-sm" v-model="order.created_at" />
                  </div>              
                  <div class="form-group">
                    <label>ARRIVED</label>
                    <input disabled type="email" class="form-control form-control-sm" v-model="order.arrived_at" />
                  </div>
                  <div class="form-group">
                    <label>RECEIVED</label>
                    <input disabled type="email" class="form-control form-control-sm" v-model="order.received_at" />
                  </div>
                  <div class="form-group">
                    <label>PUT AWAY</label>
                    <input disabled type="email" class="form-control form-control-sm" v-model="order.put_away_at" />
                  </div>                                              
                </div>            
              </div>          
            </div>

            <div class="col-4">            
              <div class="border p-4 bg-light">
                <h5 class="d-flex justify-content-between">
                  APPOINTMENT
                  <!-- <small> <i class="fa fa-edit"></i></small> -->
                </h5>
                <div class="form-row">
                  <div class="form-group col-6">
                    <label>DATE/TIME</label>
                    <input :disabled="readonly" type="text" class="form-control form-control-sm" v-model="order.appt_at" />
                  </div>
                  <div class="form-group col-6">
                    <label>DURATION</label>
                    <input :disabled="readonly" type="number" class="form-control form-control-sm" v-model="order.appt_duration" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-6">
                    <label>CONTACT NAME</label>
                    <input :disabled="readonly" type="text" class="form-control form-control-sm" v-model="order.appt_name" />
                  </div>
                  <div class="form-group col-6">
                    <label>CONTACT E-MAIL</label>
                    <input :disabled="readonly" type="email" class="form-control form-control-sm" v-model="order.appt_email" />
                  </div>
                </div>
                <div class="form-group">
                  <label>LOAD TYPE</label>
                  <input :disabled="readonly" type="datetime" class="form-control form-control-sm" v-model="order.load_type" />
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="">
          <ul class="nav nav-tabs">
            <li class="nav-item m-r" style="width: 15px;"></li>
            <li class="nav-item">
              <a class="nav-link active" href="#" data-toggle="tab" data-target="#items">
                  Items
                </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" data-toggle="tab" data-target="#docs">
                Documents
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" data-toggle="tab" data-target="#billable">
                Billable Activity
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" data-toggle="tab" data-target="#history">
                History
              </a>
            </li>
          </ul>
        </div>

        <div class="tab-content bg-white">
          <div class="tab-pane active" id="items">
            <items-tab :order="order"></items-tab>
          </div>
          <div class="tab-pane" id="docs">
            <docs-tab :order="order"></docs-tab>
          </div>
          <div class="tab-pane" id="billable">
            <billable-tab :order="order"></billable-tab>
          </div>
          <div class="tab-pane" id="history">
            <history-tab :order="order"></history-tab>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  
  import ItemsTab from '@/components/inbound/ItemsTab'
  import DocsTab from '@/components/inbound/DocsTab'
  import BillableTab from '@/components/inbound/BillableTab'
  import HistoryTab from '@/components/inbound/HistoryTab'
  import ActionButtons from '@/components/inbound/ActionButtons'
  import api from '@/api'
  export default {
    name: 'order-detail',

    components: {
      ItemsTab,
      DocsTab,
      BillableTab,
      ActionButtons,
      HistoryTab
    },

    data() {
      return {
        loading: false,
        order: {},
        readonly: true,
      }
    },

    created() {
      this.fetchData(this.$route.params.id)
    },

    watch: {
      'this.$route.params.id': function(id) {
        this.fetchData(id)
      }
    },

    methods: {
      edit() {
        this.readonly = false
      },

      cancelEdit() {
        this.readonly = true
      },

      saveEdit() {
        this.postData({ order: {
          po_number: this.order.po_number,
          container_number: this.order.container_number,
          appt_at: this.order.appt_at,
          appt_duration: this.order.appt_duration,
          appt_name: this.order.appt_name,
          appt_email: this.order.appt_email,
        }})
      },

      fetchData(id) {
        this.loading = true
        api.get('/inbound-orders/' + id).then(res => {
          this.order = res.data.order
          this.loading = false
        })
      },

      postData(params) {
        this.loading = true
        api.post(`/inbound-orders/${this.order.id}`, params).then(res => {
          this.order = res.data.order
          this.loading = false
          this.readonly = true
        })
      },
  
    }
  }
</script>
<style>

</style>
<style scoped>
label {
  font-size: 0.75rem;
  color: #666666;
}

.form-control {
  padding-left: 0.5rem;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 48px);
}

</style>